import { Box } from "@mui/system";
import { TablePagination } from "@mui/material";
import { useTranslation } from "react-i18next";
import "./ManagementsPagination.scss";
import { ROWS_PER_PAGE_OPTIONS } from "../../../core/constants/constants";

interface ManagementsPaginationProps {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  rowsPerPage: number;
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>;
  totalRegistersQuery: number;
}

const ManagementsPagination = ({
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  totalRegistersQuery,
}: ManagementsPaginationProps) => {
  const { t } = useTranslation();

  const showPagination =
    Math.ceil(totalRegistersQuery / rowsPerPage) !== 1 &&
    totalRegistersQuery >= rowsPerPage;

  return (
    <Box component="article" className="managements-pagination">
      {showPagination && (
        <TablePagination
          className="table-pagination"
          showFirstButton
          showLastButton
          component="div"
          rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
          labelRowsPerPage={t(`Tablas.Filas por página`)}
          labelDisplayedRows={({ page, count }) =>
            t("Tablas.Página de", {
              actual: page + 1,
              total: Math.ceil(count / rowsPerPage),
            })
          }
          count={totalRegistersQuery}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(
            event: React.MouseEvent<HTMLButtonElement> | null,
            newPage: number
          ) => {
            setPage(newPage);
          }}
          onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
          }}
        />
      )}
    </Box>
  );
};

export default ManagementsPagination;
